import React from 'react'
export const baseurl="https://techanalogy.org.in/admin/";
const config = () => {
  return (<>
  </>

  )
}

export default config